import {Column, Row} from "./Layout";
import {getCurrentSubDomain} from "../../HomePage";
import failureIcon from '../../../assets/ver3/nbt/failure.png'
import {Image} from "@fluentui/react-components"
import { ErrorCircleFilled } from "@fluentui/react-icons";
import {useCommonPageStyles} from "../../../styles/mission/commonStyle";

export function ThresholdPage() {

    const style= useCommonPageStyles()
    const currentSubDomain = getCurrentSubDomain();

    if(currentSubDomain === "nbt" || currentSubDomain.includes("toktokquiz")){
        return <div className={style.nbt_root}>
            <Image alt={"failure_icon"} src={failureIcon}/>
            <div className={style.textStyle}>
                오늘 참여 가능한 광고가<br/>
                모두 소진되었습니다...<br/>
                <br/>
                내일 다시 방문 부탁드립니다!
            </div>
        </div>
    }
    else {
        return <Column gap={'16px'} alignItems={'center'} justifyContent={'center'}>
            <div style={{height: '96px'}}/>
            <ErrorCircleFilled fontSize={'200px'} color={'black'}/>
            <Row>
                오늘 참여 가능한 광고가
            </Row>
            <Row>
                모두 소진되었습니다...
            </Row>
            <br/>
            <Row>
                내일 다시 방문 부탁드립니다!
            </Row>
        </Column>
    }


}